import FortnoxSettings from "./FortnoxSettings";

export default FortnoxSettings;
